<template>
    <div>
        <rkm-form
            ref="RkmForm"
        >
            <rkm-alert class="mb-2">
                <rkm-row>
                    <rkm-col cols="auto">
                        <strong>Massa</strong>
                        <div>
                            {{ data.model.avaliacaoAntropometrica.massa }}
                            {{ data.model.avaliacaoAntropometrica.massaUnidadeMedida.sigla }}
                        </div>
                    </rkm-col>

                    <rkm-col cols="auto">
                        <strong>Altura ({{ data.model.avaliacaoAntropometrica.alturaTipoMedida.nome }})</strong>
                        <div>
                            {{ data.model.avaliacaoAntropometrica.altura }}
                            {{ data.model.avaliacaoAntropometrica.alturaUnidadeMedida.sigla }}
                        </div>
                    </rkm-col>

                    <rkm-col
                        v-if="!data.form.paciente.isDesconhecido"
                        cols="auto"
                    >
                        <strong>Idade</strong>
                        <div>
                            {{ data.form.paciente.idade.anos }} ano(s)
                            {{ data.form.paciente.idade.meses }} meses(s)
                            {{ data.form.paciente.idade.dias }} dias(s)
                        </div>
                    </rkm-col>
                </rkm-row>
            </rkm-alert>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        @change="handleIsManualChange"
                        label="Tipo de prescrição"
                        v-model="model.isManual"
                    >
                        <rkm-form-select-option :value="false">Padronizado</rkm-form-select-option>
                        <rkm-form-select-option :value="true">Não padronizado</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.isManual">
                <rkm-col cols="12">
                    <rkm-text-editor
                        :validations="validations.prescricaoManual"
                        label="Descrição"
                        v-model="model.prescricaoManual"
                    />
                </rkm-col>
            </rkm-row>

            <template v-else>
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :searchFields="fields"
                            :repository="repositories.medicamento"
                            :request-query-string-params="{
                                exibir_receita: true,
                            }"
                            :validations="validations.medicamento"
                            label="Medicamento"
                            v-model="model.medicamento"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    color="primary"
                                    title="Cadastrar medicamento"
                                    @click="$refs.ModalMedicamento.open()"
                                >
                                    <rkm-icon icon="plus" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="form.disabledViaAdministracao"
                            :options="data.form.viasAdministracao"
                            :validations="validations.viaAdministracaoId"
                            @change="model.viaAdministracao.nome = getViaAdministracaoNome(model.viaAdministracao.id)"
                            label="Via de administração"
                            show-default-option
                            text-field="nome"
                            v-model="model.viaAdministracao.id"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            v-if="model.viaAdministracao.id === enums.viaAdministracao.OUTRAS"
                            :validations="validations.viaAdministracaoOutras"
                            :label="false"
                            v-model="model.viaAdministracaoOutras"
                            name="Outra"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-area title="Posologia">
                    <rkm-row class="mb-2">
                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="tiposAplicacoes"
                                @change="handleTipoAplicacao"
                                default-option-text="Padrão"
                                label="Aplicação"
                                show-default-option
                                text-field="nome"
                                v-model="model.tipoAplicacao.id"
                                value-field="id"
                            >


                                <rkm-input-group-append
                                    slot="append"
                                    v-if="!isTipoAplicacaoDoseUnica && !isTipoAplicacaoLivre"
                                >
                                    <rkm-input-group-text>
                                        <rkm-form-radio-group v-model="model.tipoPosologia">
                                            <rkm-form-radio :value="this.enums.tipoPosologia.FREQUENCIA">
                                                Frequência
                                            </rkm-form-radio>
                                            <rkm-form-radio :value="this.enums.tipoPosologia.TURNO">
                                                Turno
                                            </rkm-form-radio>
                                        </rkm-form-radio-group>
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-select>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6" v-if="!isTipoAplicacaoLivre">
                            <rkm-form-input
                                :validations="validations.quantidade"
                                label="Quantidade"
                                type="number"
                                step="0.1"
                                min="0.1"
                                v-model="model.quantidade"
                            >
                                <rkm-input-group-append
                                    class="w-75"
                                    slot="append"
                                >
                                    <rkm-form-select
                                        :disabled="form.disabledUnidadeMedida"
                                        :options="data.form.unidadesMedida"
                                        :validations="validations.unidadeMedidaId"
                                        @change="handleUnidadeMedidaChange"
                                        name="Unidade de medida"
                                        text-field="nome"
                                        v-model="model.unidadeMedida.id"
                                        value-field="id"
                                        show-default-option
                                    />
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="6" v-if="!isTipoAplicacaoDoseUnica && isTipoPosologiaFrequencia && !isTipoAplicacaoLivre">
                            <rkm-form-input
                                :label="false"
                                :validations="validations.intervaloTempo"
                                name="Intervalo"
                                type="number"
                                v-model="model.intervaloTempo"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>
                                        a cada
                                    </rkm-input-group-text>
                                </rkm-input-group-prepend>

                                <rkm-input-group-append slot="append">
                                    <rkm-form-select
                                        :options="getMedidasTempoACada"
                                        :validations="validations.intervaloTempoId"
                                        @change="model.intervaloMedidaTempo.nome = getUnidadeMedidaTempoNome(model.intervaloMedidaTempo.id)"
                                        show-default-option
                                        text-field="nome"
                                        name="Unidade de medida intervalo"
                                        v-model="model.intervaloMedidaTempo.id"
                                        value-field="id"
                                    />
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col v-else-if="!isTipoAplicacaoDoseUnica && !isTipoPosologiaFrequencia">
                            <rkm-form-select
                                :label="false"
                                :options="data.form.turnos"
                                :validations="validations.turnoId"
                                @change="model.turno.nome = getTurnoNome(model.turno.id)"
                                show-default-option
                                text-field="nome"
                                v-model="model.turno.id"
                                value-field="id"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>
                                        Pela
                                    </rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-select>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="!isTipoAplicacaoDoseUnica && !isTipoAplicacaoLivre && !isTipoAplicacaoUsoContinuo">
                        <rkm-col cols="6">
                            <rkm-form-input
                                :validations="validations.duranteQuantidade"
                                label="Durante"
                                type="number"
                                v-model="model.duranteQuantidade"
                            >
                                <rkm-input-group-append slot="append">
                                    <rkm-form-select
                                        :options="getMedidasTempoDurante"
                                        :validations="validations.duranteMedidaTempoId"
                                        @change="model.duranteMedidaTempo.nome = getUnidadeMedidaTempoNome(model.duranteMedidaTempo.id)"
                                        name="Unidade de medida durante"
                                        show-default-option
                                        text-field="nome"
                                        v-model="model.duranteMedidaTempo.id"
                                        value-field="id"
                                    />
                                </rkm-input-group-append>
                            </rkm-form-input>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="posologiaFormatada">
                        <rkm-col class="mb-2">
                            <rkm-alert color="secondary">
                                <strong>Posologia:</strong> {{ posologiaFormatada }}
                            </rkm-alert>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-form-textarea
                    v-if="!isTipoAplicacaoLivre"
                    label="Recomendações"
                    rows="3"
                    max-rows="8"
                    :maxlength="validations.recomendacoes.max"
                    v-model="model.recomendacoes"
                    :validations="validations.recomendacoes"
                />

                <rkm-form-textarea
                    v-if="isTipoAplicacaoLivre"
                    label="Descrição"
                    rows="3"
                    max-rows="8"
                    :maxlength="validations.descricao.max"
                    v-model="model.descricao"
                    :validations="validations.descricao"
                />

                <ModalMedicamento ref="ModalMedicamento" />
            </template>
        </rkm-form>

        <List
            :data="data"
            @edit="handleEdit"
        />
    </div>
</template>

<script>

// Components.
import ModalMedicamento from '@/components/pronto-atendimento/atendimento-medico/components/receita-medica/components/Modal'
import List from './List'

//Mixins
import { repository, object } from '@/mixins'

//Enums
import medidaTempo from '@/enums/cadastro/medidaTempo'
import tipoAplicacao from '@/enums/pronto-atendimento/receita/tipoAplicacao'
import tipoPosologia from '@/enums/pronto-atendimento/receita/tipoPosologia'
import viaAdministracao from '@/enums/cadastro/medicamento/viaAdministracao'

export default {
    components: { ModalMedicamento, List },
    created() {
        this.repositories = {
            medicamento: this.getConectaSusRepository('cadastro.medicamento.medicamento'),
        }

        this.model.viaAdministracao.id = null
        this.model.unidadeMedida.id = null
    },
    computed: {
        fields() {

            return [
                { key: 'nome', searchable: true },
            ]
        },
        getMedidasTempoACada() {

            return this.data.form.unidadesMedidaTempo.filter(medida => this.isMedidaTempoACada(medida.id))
        },
        getMedidasTempoDurante() {

            return this.data.form.unidadesMedidaTempo.filter(medida => this.isMedidaTempoDurante(medida.id))
        },
        posologiaFormatada() {

            let posologia = null

            if (this.isPosologiaPreenchida()) {

                if (this.isTipoAplicacaoDoseUnica) {

                    posologia = `${this.posologiaMedicamento.quantidade}
                        ${this.getUnidadeMedidaNome(this.model.unidadeMedida.id)}, dose única`

                } else {

                    posologia = `${this.posologiaMedicamento.quantidade}
                        ${this.getUnidadeMedidaNome(this.model.unidadeMedida.id)},`

                        if (this.model.turno.id) {

                            posologia = posologia.concat(
                                ` pela ${this.model.turno.nome}`
                            )

                        } else {
                            if (this.model.intervaloMedidaTempo.id === this.enums.medidaTempo.MINUTOS || this.model.intervaloMedidaTempo.id === this.enums.medidaTempo.HORAS) {
                                posologia = posologia.concat(` a cada ${this.model.intervaloTempo} ${this.getUnidadeMedidaTempoNome(this.model.intervaloMedidaTempo.id)}`)
                            }
                            else if(this.model.intervaloMedidaTempo.id === this.enums.medidaTempo.DIAS || this.model.intervaloMedidaTempo.id === this.enums.medidaTempo.SEMANAS || this.model.intervaloMedidaTempo.id === this.enums.medidaTempo.MESES) {
                                posologia = posologia.concat(` ${this.model.intervaloTempo} vez(es) ao ${this.getUnidadeMedidaTempoNome(this.model.intervaloMedidaTempo.id)}`)
                            }
                        }


                    if (this.model.duranteMedidaTempo.id) {

                        posologia = posologia.concat(
                            ` durante ${this.model.duranteQuantidade}
                                ${this.getUnidadeMedidaTempoNome(this.model.duranteMedidaTempo.id)}`
                        )
                    }
                }
            }

            return posologia
        },
        isTipoAplicacaoDoseUnica() {

            return this.model.tipoAplicacao.id === this.enums.tipoAplicacao.DOSE_UNICA
        },
        isTipoAplicacaoUsoContinuo() {

            return this.model.tipoAplicacao.id === this.enums.tipoAplicacao.USO_CONTINUO
        },
        isTipoAplicacaoLivre() {

            return this.model.tipoAplicacao.id === this.enums.tipoAplicacao.LIVRE
        },
        isTipoPosologiaFrequencia() {

            return this.model.tipoPosologia === this.enums.tipoPosologia.FREQUENCIA
        },
        tiposAplicacoes() {

            return [
                {
                    id: this.enums.tipoAplicacao.DOSE_UNICA,
                    nome: 'Dose única'
                },
                {
                    id: this.enums.tipoAplicacao.USO_CONTINUO,
                    nome: 'Uso contínuo'
                },
                {
                    id: this.enums.tipoAplicacao.LIVRE,
                    nome: 'Livre'
                }
            ]
        },
        validations() {

            return {
                medicamentoManual: { required: true, max: 500 },
                viaAdministracaoId: { required: true },
                viaAdministracaoOutras: {
                    required: this.model.viaAdministracao.id === this.enums.viaAdministracao.OUTRAS,
                    max: 100
                },
                unidadeMedidaId: { required: true },
                intervaloTempo: { required: true, min: 1, max: 3 },
                intervaloTempoId: { required: true },
                turnoId: { required: true },
                duranteQuantidade: { required: true, numeric: true, min: 1, max: 3 },
                duranteMedidaTempoId: { required: true },
                quantidade: { required: true, min: 0.1, min_value: 0.1, max: 3 },
                recomendacoes: { max: 250 },
                descricao: { required: true, max: 250 },
                prescricaoManual: { required: true },
            }
        },
        posologiaMedicamento() {

            return {

                quantidade: this.model.quantidade.toString().replace('.', ',')
            }
        }
    },
    data: () => ({
        enums: { tipoAplicacao, tipoPosologia, viaAdministracao, medidaTempo },
        form: {
            disabledViaAdministracao: true,
            disabledUnidadeMedida: true,
        },
        model: {
            id: null,
            medicamentoCadastrado: 1,
            medicamento: null,
            viaAdministracao: {
                id: null,
                nome: null,
            },
            viaAdministracaoOutras: null,
            tipoAplicacao: {
                id: null,
                nome: null,
            },
            tipoPosologia: 1,
            quantidade: 1,
            unidadeMedida: {
                id: null,
                nome: null,
                sigla: null,
            },
            intervaloTempo: 1,
            intervaloMedidaTempo: {
                id: null,
                nome: null,
            },
            duranteQuantidade: 1,
            duranteMedidaTempo: {
                id: null,
                nome: null,
            },
            turno: {
                id: null,
                nome: null,
            },
            recomendacoes: null,
            descricao: null,
            isManual: false,
            prescricaoManual: null,
        },
        isModelTouched: false,
        unwatchers: {
            unwatchModel: null,
        },
    }),
    methods: {
        getUnidadeMedidaTempoNome(id) {

            if (id == null) {

                return null
            }

            return this.data.form.unidadesMedidaTempo
                .find(u => u.id === id).nome
        },
        getUnidadeMedidaNome(id) {

            if (id == null) {

                return null
            }

            return this.data.form.unidadesMedida
                .find(f => f.id === id).nome
        },
        getViaAdministracaoNome(id) {

            if (id == null) {

                return null
            }

            return this.data.form.viasAdministracao
                .find(v => v.id === id).nome
        },
        getTurnoNome(id) {

            if (id == null) {

                return null
            }

            return this.data.form.turnos
                .find(t => t.id === id).nome
        },
        handleTipoAplicacao(id) {

            if (this.model.tipoAplicacao.id == null) {

                this.model.tipoAplicacao.nome = null

                return
            }

            this.model.tipoAplicacao.nome = this.tiposAplicacoes.find(t => t.id === id).nome
        },
        isMedidaTempoACada(id) {
            return [
                medidaTempo.MINUTOS,
                medidaTempo.HORAS,
                medidaTempo.DIAS,
                medidaTempo.SEMANAS,
                medidaTempo.MESES
            ].indexOf(id) !== -1
        },
        isMedidaTempoDurante(id) {
            return [
                medidaTempo.DIAS,
                medidaTempo.SEMANAS,
                medidaTempo.MESES
            ].indexOf(id) !== -1
        },
        isPosologiaPreenchida() {

            if (this.isTipoAplicacaoDoseUnica) {

                return this.model.quantidade && this.model.unidadeMedida.id
            }

            const qtdeUnidadeMedida = this.model.quantidade && this.model.unidadeMedida.id
            const intervalo = this.model.intervaloTempo && this.model.intervaloMedidaTempo.id
            const isFrequencia = this.model.tipoPosologia === this.enums.tipoPosologia.FREQUENCIA
            const isTurno = this.model.tipoPosologia === this.enums.tipoPosologia.TURNO
            const duranteTempo = this.model.duranteQuantidade && this.model.duranteMedidaTempo.id


            return this.isTipoAplicacaoDoseUnica && qtdeUnidadeMedida
                || (
                    qtdeUnidadeMedida
                    && (
                        duranteTempo
                        && (
                            (isFrequencia && intervalo)
                            || (isTurno && this.model.turno.id)
                        )
                    )
                    || (
                        this.isTipoAplicacaoUsoContinuo
                        && (
                            (isFrequencia && intervalo)
                            || (isTurno && this.model.turno.id)
                        )
                    )
                )
        },
        save() {

            this.$refs.RkmForm.validate().then(response => {

                if (response) {

                    if (this.model.id) {

                        const index = this.data.model.receitaMedica.medicamentos
                            .findIndex(item => item.medicamento.id === this.model.medicamento.id)

                        this.data.model.receitaMedica.medicamentos[index] = JSON.parse(JSON.stringify(this.model))

                    } else {

                        this.isModelTouched = true

                        if (this.model.medicamento) {
                            if (this.hasMedicamentoOnReceita(this.model.medicamento.id)) {

                                this.createNotification({
                                    type: 'alert',
                                    color: 'danger',
                                    title: 'Ação não permitida',
                                    message: 'Medicamento já receitado!'
                                })

                                return
                            }
                        }

                        this.model.id = this.uniqueId('pronto-atendimento-atendimento-medico-receita-medica');
                        this.data.model.receitaMedica.medicamentos.push(JSON.parse(JSON.stringify(this.model)))
                    }

                    this.$emit('saved', {
                        isModelTouched: this.isModelTouched,
                        model: this.model,
                    })

                    this.form.disabledViaAdministracao = true
                    this.form.disabledUnidadeMedida = true

                    this.model.id = null,
                    this.model.medicamentoCadastrado = 1,
                    this.model.medicamento = null

                    this.model.viaAdministracao = {
                        id: null,
                        nome: null,
                    }

                    this.model.viaAdministracaoOutras = null

                    this.model.tipoAplicacao = {
                        id: null,
                        nome: null,
                    }

                    this.model.tipoPosologia = 1
                    this.model.quantidade = 1

                    this.model.unidadeMedida = {
                        id: null,
                        nome: null,
                        sigla: null,
                    }

                    this.model.intervaloTempo = 1

                    this.model.intervaloMedidaTempo = {
                        id: null,
                        nome: null,
                    }

                    this.model.duranteQuantidade = 1

                    this.model.duranteMedidaTempo = {
                        id: null,
                        nome: null,
                    }

                    this.model.turno = {
                        id: null,
                        nome: null,
                    }

                    this.model.recomendacoes = null
                    this.model.descricao = null
                    this.model.prescricaoManual = null

                    this.isModelTouched = false

                    this.$refs.RkmForm.resetValidator()
                }
            })
        },
        hasMedicamentoOnReceita(medicamentoId) {

            const medicamentos = this.data.model.receitaMedica.medicamentos
            if (medicamentos.length > 0) {

                return !!medicamentos.find(m => m.medicamento && m.medicamento.id === medicamentoId )
            }
        },
        load(model) {

            this.isModelTouched = false

            if (this.unwatchers.unwatchModel !== null) {

                this.unwatchers.unwatchModel()
            }

            if (model) {

                model = JSON.parse(JSON.stringify(model))

                this.model.id = model.id
                this.model.medicamentoCadastrado = model.medicamentoCadastrado

                this.$nextTick()
                    .then(() => {

                        this.model.isManual = model.isManual
                        this.model.prescricaoManual = model.prescricaoManual

                        return this.$nextTick()
                    })
                    .then(() => {

                        this.model.medicamentoManual = model.medicamentoManual

                        return this.$nextTick()
                    })
                    .then(() => {

                        this.model.medicamento = model.medicamento

                        return this.$nextTick()
                    })
                    .then(() => {

                        this.model.viaAdministracao = {
                            id: model.viaAdministracao.id,
                            nome: model.viaAdministracao.nome,
                        }

                        return this.$nextTick()
                    })
                    .then(() => {

                        this.model.viaAdministracaoOutras = model.viaAdministracaoOutras

                        this.model.tipoAplicacao = {
                            id: model.tipoAplicacao.id,
                            nome: model.tipoAplicacao.nome,
                        }

                        this.model.tipoPosologia = model.tipoPosologia

                        return this.$nextTick()
                    })
                    .then(() => {

                        this.model.quantidade = model.quantidade

                        this.model.unidadeMedida = {
                            id: model.unidadeMedida.id,
                            nome: model.unidadeMedida.nome,
                            sigla: model.unidadeMedida.sigla,
                        }

                        this.model.intervaloTempo = model.intervaloTempo

                        this.model.intervaloMedidaTempo = {
                            id: model.intervaloMedidaTempo.id,
                            nome: model.intervaloMedidaTempo.nome,
                        }

                        this.model.duranteQuantidade = model.duranteQuantidade

                        this.model.duranteMedidaTempo = {
                            id: model.duranteMedidaTempo.id,
                            nome: model.duranteMedidaTempo.nome,
                        }

                        this.model.turno = {
                            id: model.turno.id,
                            nome: model.turno.nome,
                        }

                        this.model.recomendacoes = model.recomendacoes
                        this.model.descricao = model.descricao

                        return this.$nextTick()
                    })
                    .then(() => this.addModelWatcher())
            }
        },
        addModelWatcher() {

            this.unwatchers.unwatchModel = this.$watch('model', {
                deep: true,
                handler() {

                    this.isModelTouched = true

                    this.unwatchers.unwatchModel()
                }
            })
        },
        getUnidadeMedidaSigla(id) {

            if (id == null) {

                return null
            }

            return this.data.form.unidadesMedida
                .find(f => f.id === id).sigla
        },
        handleUnidadeMedidaChange() {
            this.model.unidadeMedida.nome = this.getUnidadeMedidaNome(this.model.unidadeMedida.id)
            this.model.unidadeMedida.siga = this.getUnidadeMedidaSigla(this.model.unidadeMedida.id)
        },
        handleIsManualChange() {
            this.form.disabledViaAdministracao = true
            this.form.disabledUnidadeMedida = true

            this.model.medicamentoCadastrado = 1
            this.model.medicamento = null

            this.model.viaAdministracao = {
                id: null,
                nome: null,
            }

            this.model.viaAdministracaoOutras = null

            this.model.tipoAplicacao = {
                id: null,
                nome: null,
            }

            this.model.tipoPosologia = 1
            this.model.quantidade = 1

            this.model.unidadeMedida = {
                id: null,
                nome: null,
                sigla: null,
            }

            this.model.intervaloTempo = 1

            this.model.intervaloMedidaTempo = {
                id: null,
                nome: null,
            }

            this.model.duranteQuantidade = 1

            this.model.duranteMedidaTempo = {
                id: null,
                nome: null,
            }

            this.model.turno = {
                id: null,
                nome: null,
            }

            this.model.recomendacoes = null
            this.model.descricao = null
            this.model.prescricaoManual = null

            this.isModelTouched = false
        },
        handleEdit(item) {
            this.load(item)
        },
    },
    mixins: [ repository, object ],
    watch: {
        'model.medicamentoCadastrado': function () {

            this.model.medicamento = null
            this.form.disabledViaAdministracao = true
            this.form.disabledUnidadeMedida = true
            this.model.viaAdministracao.id = null
        },
        'model.medicamento': function (item) {

            if (!item) {

                return
            }

            this.form.disabledViaAdministracao = item ? true : false

            this.model.viaAdministracao.id = item ? item.viaAdministracaoId : null
            this.model.viaAdministracao.nome = this.getViaAdministracaoNome(this.model.viaAdministracao.id)

            this.model.unidadeMedida.id = item ? item.unidadeMedidaId : null
            this.model.unidadeMedida.nome = this.getUnidadeMedidaNome(this.model.unidadeMedida.id)
            this.model.unidadeMedida.sigla = this.getUnidadeMedidaSigla(this.model.unidadeMedida.id)
        },
        'model.tipoPosologia': function () {

            this.model.intervaloTempo = 1
            this.model.intervaloMedidaTempo.id = null
            this.model.intervaloMedidaTempo.nome = null
            this.model.turno.id = null
            this.model.turno.nome = null
        },
        'model.viaAdministracao.id': function () {

            this.model.viaAdministracaoOutras = null
        },
        'model.tipoAplicacao.id': function () {

            if (this.isTipoAplicacaoDoseUnica || this.isTipoAplicacaoLivre) {

                this.model.duranteMedidaTempo.id = null
                this.model.duranteMedidaTempo.nome = null
            }
        }
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>